import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import MobileCtaBar from "@/components/MobileCtaBar";
import { fbTrack } from "@/lib/pixel";

export default function Layout() {
  const { pathname } = useLocation();
  const first = useRef(true);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    if (first.current) {
      first.current = false;
      return;
    }
    fbTrack("PageView");
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-[#050505] text-white relative pb-[72px] md:pb-0">
      <Navbar />
      <main className="flex-1 relative z-10">
        <Outlet />
      </main>
      <Footer />
      <ChatWidget />
      <MobileCtaBar />
    </div>
  );
}
